// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAz4YpDc4GhbeIJjRgJIZ4sXRLXx6h9JNc",
  authDomain: "car-services-4c0e1.firebaseapp.com",
  projectId: "car-services-4c0e1",
  storageBucket: "car-services-4c0e1.appspot.com",
  messagingSenderId: "668864398337",
  appId: "1:668864398337:web:853fb854661522d054ac00"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;